const top20Overview = [
  {
      "university": "Harvard University",
      "country": "USA",
      "centiMillionaires": "1088",
      "centiGrowth": "3.8"
  },
  {
      "university": "Stanford University",
      "country": "USA",
      "centiMillionaires": "629",
      "centiGrowth": "2.2"
  },
  {
      "university": "University of Pennsylvania",
      "country": "USA",
      "centiMillionaires": "538",
      "centiGrowth": "1.9"
  },
  {
      "university": "University of Oxford",
      "country": "UK",
      "centiMillionaires": "490",
      "centiGrowth": "1.7"
  },
  {
      "university": "Massachusetts Institute of Technology",
      "country": "USA",
      "centiMillionaires": "486",
      "centiGrowth": "1.7"
  },
  {
      "university": "Yale University",
      "country": "USA",
      "centiMillionaires": "472",
      "centiGrowth": "1.7"
  },
  {
      "university": "University of Cambridge",
      "country": "UK",
      "centiMillionaires": "405",
      "centiGrowth": "1.4"
  },
  {
      "university": "Columbia University",
      "country": "USA",
      "centiMillionaires": "392",
      "centiGrowth": "1.4"
  },
  {
      "university": "Princeton University",
      "country": "USA",
      "centiMillionaires": "330",
      "centiGrowth": "1.2"
  },
  {
      "university": "INSEAD",
      "country": "France",
      "centiMillionaires": "258",
      "centiGrowth": "0.9"
  },
  {
      "university": "Cornell University",
      "country": "USA",
      "centiMillionaires": "234",
      "centiGrowth": "0.8"
  },
  {
      "university": "Tsinghua University",
      "country": "China",
      "centiMillionaires": "222",
      "centiGrowth": "0.8"
  },
  {
      "university": "London School of Economics",
      "country": "UK",
      "centiMillionaires": "215",
      "centiGrowth": "0.8"
  },
  {
      "university": "University of Tokyo",
      "country": "Japan",
      "centiMillionaires": "206",
      "centiGrowth": "0.7"
  },
  {
      "university": "University of California, Berkeley",
      "country": "USA",
      "centiMillionaires": "202",
      "centiGrowth": "0.7"
  },
  {
      "university": "Peking University",
      "country": "China",
      "centiMillionaires": "194",
      "centiGrowth": "0.7"
  },
  {
      "university": "London Business School",
      "country": "UK",
      "centiMillionaires": "180",
      "centiGrowth": "0.6"
  },
  {
      "university": "University of Chicago",
      "country": "USA",
      "centiMillionaires": "178",
      "centiGrowth": "0.6"
  },
  {
      "university": "University of Southern California",
      "country": "USA",
      "centiMillionaires": "175",
      "centiGrowth": "0.6"
  },
  {
      "university": "HEC Paris",
      "country": "France",
      "centiMillionaires": "172",
      "centiGrowth": "0.6"
  }
];


const univTotalData = [
  {
      "university": "",
      "country": "",
      "centiMillionaires": "7066",
      "centiGrowth": "24.9"
  }
];

export {top20Overview, univTotalData};